export default "__VITE_ASSET__C4lJ8Lnf__"